// @ts-nocheck
import commonDesign from "@store/Themes/common/styleguide/config/design";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const design: Styleguide["design"] = {
    ...commonDesign,
    header: {
        iconButton: {
            size: pxToRemArray([30, null, 30]),
        },
    },
    typography: {
        ...commonDesign?.typography,
        fontFamily: {
            title: `Oswald, Univers, Arial, Helvetica, sans-serif`,
            base: `Univers, Arial, Helvetica, sans-serif`,
        },
    },
};

export default design;
